<template>
  <div>
    <!-- snackbar -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- overlay -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin -->

    <!-- SS :{{ sel_crs.length }}
        <template v-if="sel_crs.length > 0">
        {{ sel_crs }}
        </template> -->
    <v-row dense justify="center">
      <v-col cols="12" sm="3" md="3">
        <v-btn class="button" @click="call">
          <v-icon color="warning">mdi-refresh</v-icon>
          Refresh</v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="4" md="4">
        <b>Meeting Code :: </b>
        <span class="meeting-code"><v-text-field rounded dense outlined label="Enter Meeting Code"
            v-model="meeting_code_new" single-line hide-details></v-text-field> </span>
      </v-col>
      <v-col cols="12" sm="1" md="1">
        <br>
        <v-btn class="mt-2" color="orange" @click="saveMeetCode()">Save</v-btn>
      </v-col>

    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="4" md="4">

        <template v-if="link_join">
          <a :href="link_join" target="_blank">
            <v-btn color="primary">Join Meet</v-btn>
          </a>
        </template>
        <template v-else>
          <v-btn color="primary" disabled>Join Meet</v-btn>
        </template>

      </v-col></v-row>


    <!-- <template v-if="show_screen">
      <share :meeting_code="meeting_code" />
    </template> -->
  </div>
</template>
<script>
import axios from "axios";
//import Share from "./Share.vue";
export default {
  // components: {
  //   share: Share,
  // },
  props: ["sel_crs"],
  data: () => ({
    meeting_code_new: "",
    snackbar_msg: "",
    link_join: "",
    color: "",
    snackbar: false,
    overlay: false,
    ///////////////////////////////////////////////
    meeting_code: null,
    show_screen: false,
    name: "vikas", aws_path: ""
  }),
  methods: {
    async saveMeetCode() {
      this.overlay = true;
      const formdata = {
        livesession_id: this.livesession_id,
        meeting_code: this.meeting_code_new,
      };
      try {
        const res = await axios.post("/liveClass/saveMeetCode", formdata);
        if (res.data.flag == "YES") {
          this.meeting_code = res.data.meeting_code;
          this.livesession_id = res.data.livesession_id

          this.link_join = this.meeting_code;

          this.show_screen = true;
        } if (res.data.flag == "No") {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        // else {
        //   this.showSnackbar("red", res.data.snackbar);
        //   sessionStorage.setItem("error-trace", res.data.error_trace);
        // }
        this.overlay = false;
      } catch (err) {
        console.log("err", err);
        this.onerror(err);
        this.overlay = false;
      } finally {
        console.log("bye...");
        this.overlay = false;
      }
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    ///////////
    async call() {
      this.overlay = true;
      const formdata = {
        sel_crs: this.sel_crs,
      };
      try {
        const res = await axios.post("/liveClass/getLiveSession", formdata);
        if (res.data.flag == "YES") {
          this.meeting_code_new = res.data.meeting_code;
          if (this.meeting_code_new) {
            this.link_join = this.meeting_code_new;
          }

          this.livesession_id = res.data.livesession_id
          this.show_screen = true;
        } if (res.data.flag == "No") {
          this.livesession_id = res.data.livesession_id
          this.show_screen = true;
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        // else {
        //   this.showSnackbar("red", res.data.snackbar);
        //   sessionStorage.setItem("error-trace", res.data.error_trace);
        // }
        this.overlay = false;
      } catch (err) {
        console.log("err", err);
        this.onerror(err);
        this.overlay = false;
      } finally {
        console.log("bye...");
        this.overlay = false;
      }
    },
  },
  mounted() {
    console.log("sel_crs", this.sel_crs);
    this.call();
  },
  created() {
    this.aws_path = localStorage.getItem("awspath");
  },
};
</script>
<style scoped>
.meeting-code {
  color: #3f51b5;
  font-size: 21px;
  font-weight: 500;
}
</style>